import React, { useEffect } from 'react';
import { captureException } from '@sentry/browser';
import {
  recordShow,
  recordDismissal,
  recordClickthrough,
} from 'js/utils/dismissibles';
import { fsEvent } from 'js/fullstory';

import { CommonModal } from './common';

import { initPromise } from 'js/i18next/initI18next';
initPromise.catch((error) => {
  error.message = `i18next initialization error: ${error.message}`;
  captureException(error);
});

// @ts-expect-error ts(2307)
import PaperClaimingI18nResources from '@alienfast/i18next-loader?include=**/reg_path/signup_to_download/paper_claiming/PaperClaiming.json!config/locales_i18next/index.js';

// @ts-expect-error ts(2307)
import AuthorClaimingI18nResources from '@alienfast/i18next-loader?include=**/reg_path/signup_to_download/author_claiming/AuthorClaiming.json!config/locales_i18next/index.js';

// @ts-expect-error ts(2307)
import PaperTitleI18nResources from '@alienfast/i18next-loader?include=**/reg_path/signup_to_download/paper_title/PaperTitle.json!config/locales_i18next/index.js';

import addResources from 'js/i18next/addResources';
import { KiiSource } from 'js/kii_component/api/KiiDataApi';
import { useToast } from 'js/design_system/toasts/hooks';

addResources(
  AuthorClaimingI18nResources,
  'RegPath.SignupToDownload.AuthorClaiming',
);
addResources(
  PaperClaimingI18nResources,
  'RegPath.SignupToDownload.PaperClaiming',
);
addResources(PaperTitleI18nResources, 'RegPath.SignupToDownload.PaperTitle');

type Props = {
  open: boolean;
  onClose: () => void;
  kiiSource: KiiSource;
  headingText: string;
  subheadingText: string;
};

function KiiCollectionModal({
  onClose,
  open,
  kiiSource,
  headingText,
  subheadingText,
}: Props) {
  const { toast } = useToast();

  const nagName = 'KiiCollectionModal';

  useEffect(() => {
    recordShow(nagName);
    fsEvent(nagName);
  }, []);

  const hide = (submitted?: boolean) => {
    if (submitted === true) {
      recordClickthrough(nagName);
      fsEvent(`${nagName}-actual-submit`);

      toast({
        text: '✓ Thank you for your submission',
        placement: 'top',
      });
    }

    recordDismissal(nagName);
    onClose();
  };

  const imageName = 'arc_wireframe.svg';

  return (
    <CommonModal
      open={open}
      imageName={imageName}
      headingText={headingText}
      subheadingText={subheadingText}
      hide={hide}
      kiiSource={kiiSource}
      defaultViewType={'paper_claiming'}
    />
  );
}

export default KiiCollectionModal;
